import React from 'react';
import DashboardListIcons from '../../Components/Dashboard/DashboarListIcon/DashboardListIcons';
import TopNav from '../../Components/Dashboard/Top-Nav/TopNav';
import { useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';

function Preview() {
  const { id } = useParams();
  const { procedure } = useSelector(
    state => ({
      procedure: state.Procedure.procedures.find(p => p._id === id),
    }),
    shallowEqual
  );
  return (
    <>
      <div
        className="Dashboard flex w-full place-content-center pt-2 h-[100vh]"
        style={{
          backgroundColor: '#eceff4',
        }}
      >
        <div className="flex">
          <DashboardListIcons />
          <div className="middle" style={{ backgroundColor: '#eceff4' }}>
            <TopNav heading={'Procedure View'} />
            <div className="max-h-[100%] p-5 bg-white rounded-xl ">
              <div className="flex flex-col max-h-[50vh] overflow-auto ">
                {[...(procedure.steps || [])].sort((a, b) => a.sequence - b.sequence).map((pro, index) => (
                  <>
                    <div className="flex flex-col h-[50%] w-[100%]">
                      <h4
                        style={{
                          color: '#fe104d',
                          textTransform: 'capitalize',
                        }}
                      >
                        Step {index + 1}:
                      </h4>
                      <p>{pro.tableOfContent}</p>
                      <div className="flex gap-2 h-[80px] w-[100%]">
                        {pro.images.map((_img, _index) => (
                          <div className="h-[80px] w-[100px] border border-black">
                            <img
                              src={`${process.env.REACT_APP_URL}/public/${_img.name}`}
                              className="h-[100%] w-[100%]"
                            />
                          </div>
                        ))}
                      </div>

                      <h4
                        style={{
                          color: '#fe104d',
                          textTransform: 'capitalize',
                        }}
                      >
                        Information Notes:
                      </h4>
                      <div
                        dangerouslySetInnerHTML={{ __html: pro.information }}
                      ></div>
                    </div>
                    <div className="h-[50%] w-[100%]">
                      <h4
                        style={{
                          color: '#fe104d',
                          textTransform: 'capitalize',
                        }}
                      >
                        Decisions:
                      </h4>
                      {pro.decisions.map((_dec, _index) => (
                        <div className="f]lex flex-col">
                          <p>{_dec.textContent}</p>
                          <a
                            className="text-blue-800"
                            href={_dec.link}
                            target={'_blank'}
                          >
                            {_dec.link}
                          </a>
                        </div>
                      ))}
                    </div>

                    <div className="h-[50%] w-[100%]">
                      <h4
                        style={{
                          color: '#fe104d',
                          textTransform: 'capitalize',
                        }}
                      >
                        Diagrams:
                      </h4>
                      <div className="flex gap-2 h-[80px] w-[100%]">
                        {pro.diagrams.map((_dia, _index) => (
                          <div className="h-[80px] w-[100px] border border-black">
                            <img
                              src={`${process.env.REACT_APP_URL}/public/${_dia.name}`}
                              className="h-[100%] w-[100%]"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ))}

                {/* <div className="h-[50%] w-[100%] border border-black">{id}</div>
              <div className="h-[50%] w-[100%] border border-black">{id}</div>
              <div className="h-[50%] w-[100%] border border-black">{id}</div> */}
              </div>

              <h3>Feedback:</h3>
              <div className="min-h-[25vh] mt-5 rounded-xl bg-slate-500">
                <div className="h-[100%] w-[100%]">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Iure, eligendi. Porro reprehenderit commodi a eligendi,
                  placeat nisi doloribus laboriosam maiores ipsa atque at
                  aliquam. Excepturi soluta aperiam eaque esse accusantium.
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit. Id,
                  ullam sed vero, cupiditate adipisci harum corrupti ab quod
                  ipsum cumque tempore tempora maiores laboriosam corporis
                  consectetur. Repellat facilis eos ducimus! Lorem ipsum dolor
                  sit amet consectetur adipisicing elit. Sapiente, quas
                  exercitationem sed maxime tempore earum, mollitia quam
                  deserunt iusto quos suscipit placeat quod alias autem
                  consequatur adipisci laborum, sit harum. Lorem ipsum dolor sit
                  amet consectetur adipisicing elit. Blanditiis ipsum reiciendis
                  ratione deserunt. Magnam deserunt, eligendi eos sit hic dolore
                  distinctio rem corporis facilis possimus dolor laboriosam,
                  dicta sapiente aperiam. Lorem ipsum dolor sit, amet
                  consectetur adipisicing elit. Cupiditate eos cum harum et,
                  modi ipsam perferendis est consequuntur at, labore nemo
                  necessitatibus. Accusantium perferendis omnis voluptatibus qui
                  cum neque quam!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Preview;
